/**
 * Signature color for all demo-mode UI (banner, settings controls). Deliberately a loud
 * purple used nowhere else in the product, so being in demo mode is unmistakable and
 * can't be confused with cloaking (blue) or any customer branding.
 */
// eslint-disable-next-line import/prefer-default-export
export const DEMO_MODE_COLOR = '#7B1FA2'
